import React from 'react'
import ReactTooltip from 'react-tooltip'

import AddGuestButton from '../AddGuestButton'
import ArrivalRow from '../ArrivalRow'
import styles from './ArrivalList.module.scss'

function sortResults(results, sortIndex, sortAscending) {
  const sortedData = results.sort((a, b) => {
    switch (sortIndex) {
      case 1:
        if (a.guestFirstName === b.guestFirstName) return 0

        return a?.guestFirstName?.toUpperCase() > b?.guestFirstName?.toUpperCase()
          ? 1
          : -1

      case 2:
        return a.cityState > b.cityState ? 1 : -1

      case 3:
        return Number(a.roomNumber) - Number(b.roomNumber)

      case 4:
        return new Date(a.checkIn) - new Date(b.checkIn)

      case 5:
        return new Date(a.checkOut) - new Date(b.checkOut)

      case 6:
        if (a.phoneNumber && !b.phoneNumber) {
          return -1
        }

        if (!a.phoneNumber && b.phoneNumber) {
          return 1
        }

        if (b.phoneNumberInvalid) {
          return -2
        }

        return 0

      case 7:
        if (a.dayBeforeCheckInMessage.isSent && !b.dayBeforeCheckInMessage.isSent) {
          return 1
        }

        if (!a.dayBeforeCheckInMessage.isSent && b.dayBeforeCheckInMessage.isSent) {
          return -1
        }

        return 0

      case 8:
        if (a.duringCheckinMessage.isSent && !b.duringCheckinMessage.isSent) {
          return 1
        }

        if (!a.duringCheckinMessage.isSent && b.duringCheckinMessage.isSent) {
          return -1
        }

        return 0

      default:
        return 0
    }
  })

  return sortAscending ? sortedData : sortedData.reverse()
}

function filterResults(results, filterKey) {
  if (!filterKey || filterKey === '' || filterKey.length < 3) {
    return results
  }

  return results.filter(a => a.searchKey.toUpperCase().includes(filterKey.toUpperCase()))
}

function ArrivalListTable({
  arrivals,
  groupBookingsWithSameName,
  sortAscending,
  sortIndex,
  filterKey,
  tab,
  handleSetupClick,
  handleAddGuestClick
}) {
  const checkin = React.useMemo(
    () => arrivals.filter(c => c.status === 'InUse'),
    [arrivals]
  )
  const today = React.useMemo(
    () => arrivals.filter(t => t.status !== 'InUse'),
    [arrivals]
  )

  const filteredResults = React.useMemo(() => {
    return filterResults(tab === 'checkin' ? checkin : today, filterKey)
  }, [checkin, filterKey, tab, today])

  const sortedResults = React.useMemo(() => {
    return sortResults(filteredResults, sortIndex, sortAscending).reduce((acc, cur) => {
      if (!groupBookingsWithSameName) {
        return [...acc, cur]
      }

      if (
        acc.find(
          a =>
            a.guestFirstName + a.guestLastName === cur.guestFirstName + cur.guestLastName
        )
      ) {
        return acc
      }

      return [...acc, cur]
    }, [])
  }, [filteredResults, groupBookingsWithSameName, sortAscending, sortIndex])

  if (sortedResults.length === 0) {
    return (
      <div className={styles.noResults}>
        <p>No guests found. Walk-in guest?</p>
        <AddGuestButton onClick={handleAddGuestClick} />
      </div>
    )
  }

  return (
    <>
      <ReactTooltip className={styles.loyaltyTooltip} />
      {sortedResults.map(arrival => (
        <ArrivalRow
          key={arrival.subscriberHotelBookingId}
          handleClick={handleSetupClick}
          {...arrival}
          tab={tab}
        />
      ))}
    </>
  )
}

// export memoized table
export default ArrivalListTable
